import type { BadgeVariant } from './Badge';

const SYSTEM_TAG_VARIANTS: Readonly<Record<string, BadgeVariant>> = {
  battlecard: 'error',
  'competitor-analysis': 'error',
  'objection-handling': 'warning',
  pricing: 'warning',
  product: 'primary',
  playbook: 'purple',
  script: 'purple',
  'support-guide': 'success',
  faq: 'success',
  policy: 'default',
  manual: 'info',
  'white-paper': 'info',
};

const SYSTEM_TAG_PRIORITY = [
  'battlecard',
  'competitor-analysis',
  'objection-handling',
  'pricing',
  'product',
  'playbook',
  'script',
  'support-guide',
  'faq',
  'policy',
  'manual',
  'white-paper',
] as const;

function normalizeTag(tag: string): string {
  return tag.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

/** Choose a stable shared-ui color for the most specific system tag on an article. */
export function getKnowledgeBaseReferenceBadgeVariant(tags: readonly string[]): BadgeVariant {
  const normalizedTags = new Set(tags.map(normalizeTag));
  const primaryTag = SYSTEM_TAG_PRIORITY.find((tag) => normalizedTags.has(tag));
  return primaryTag ? SYSTEM_TAG_VARIANTS[primaryTag] : 'info';
}
